/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AggregateKeyInfo } from './AggregateKeyInfo';
import {
    AggregateKeyInfoFromJSON,
    AggregateKeyInfoFromJSONTyped,
    AggregateKeyInfoToJSON,
} from './AggregateKeyInfo';
import type { DateSearch } from './DateSearch';
import {
    DateSearchFromJSON,
    DateSearchFromJSONTyped,
    DateSearchToJSON,
} from './DateSearch';
import type { UnaccentTextSearch } from './UnaccentTextSearch';
import {
    UnaccentTextSearchFromJSON,
    UnaccentTextSearchFromJSONTyped,
    UnaccentTextSearchToJSON,
} from './UnaccentTextSearch';

/**
 * 
 * @export
 * @interface FichierSearchDto
 */
export interface FichierSearchDto {
    /**
     * 
     * @type {UnaccentTextSearch}
     * @memberof FichierSearchDto
     */
    fileName?: UnaccentTextSearch;
    /**
     * 
     * @type {UnaccentTextSearch}
     * @memberof FichierSearchDto
     */
    uploadUser?: UnaccentTextSearch;
    /**
     * 
     * @type {DateSearch}
     * @memberof FichierSearchDto
     */
    uploadDate?: DateSearch;
    /**
     * 
     * @type {Array<string>}
     * @memberof FichierSearchDto
     */
    sortKey?: Array<string> | null;
    /**
     * 
     * @type {Array<AggregateKeyInfo>}
     * @memberof FichierSearchDto
     */
    aggregateKeys?: Array<AggregateKeyInfo> | null;
    /**
     * 
     * @type {number}
     * @memberof FichierSearchDto
     */
    forceSkip?: number | null;
    /**
     * 
     * @type {number}
     * @memberof FichierSearchDto
     */
    forceTake?: number | null;
    /**
     * 
     * @type {any}
     * @memberof FichierSearchDto
     */
    parameters?: any | null;
    /**
     * 
     * @type {string}
     * @memberof FichierSearchDto
     */
    filter?: string | null;
}

/**
 * Check if a given object implements the FichierSearchDto interface.
 */
export function instanceOfFichierSearchDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FichierSearchDtoFromJSON(json: any): FichierSearchDto {
    return FichierSearchDtoFromJSONTyped(json, false);
}

export function FichierSearchDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FichierSearchDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'fileName': !exists(json, 'fileName') ? undefined : UnaccentTextSearchFromJSON(json['fileName']),
        'uploadUser': !exists(json, 'uploadUser') ? undefined : UnaccentTextSearchFromJSON(json['uploadUser']),
        'uploadDate': !exists(json, 'uploadDate') ? undefined : DateSearchFromJSON(json['uploadDate']),
        'sortKey': !exists(json, 'sortKey') ? undefined : json['sortKey'],
        'aggregateKeys': !exists(json, 'aggregateKeys') ? undefined : (json['aggregateKeys'] === null ? null : (json['aggregateKeys'] as Array<any>).map(AggregateKeyInfoFromJSON)),
        'forceSkip': !exists(json, 'forceSkip') ? undefined : json['forceSkip'],
        'forceTake': !exists(json, 'forceTake') ? undefined : json['forceTake'],
        'parameters': !exists(json, 'parameters') ? undefined : json['parameters'],
        'filter': !exists(json, 'filter') ? undefined : json['filter'],
    };
}

export function FichierSearchDtoToJSON(value?: FichierSearchDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'fileName': UnaccentTextSearchToJSON(value.fileName),
        'uploadUser': UnaccentTextSearchToJSON(value.uploadUser),
        'uploadDate': DateSearchToJSON(value.uploadDate),
        'sortKey': value.sortKey,
        'aggregateKeys': value.aggregateKeys === undefined ? undefined : (value.aggregateKeys === null ? null : (value.aggregateKeys as Array<any>).map(AggregateKeyInfoToJSON)),
        'forceSkip': value.forceSkip,
        'forceTake': value.forceTake,
        'parameters': value.parameters,
        'filter': value.filter,
    };
}

